/* import __COLOCATED_TEMPLATE__ from './session-copy.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { hash, all, filter } from 'rsvp';
import { dropTask, restartableTask, timeout } from 'ember-concurrency';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { DateTime } from 'luxon';
import { findById, sortBy } from 'ilios-common/utils/array-helpers';
let SessionCopyComponent = (_class = class SessionCopyComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "flashMessages", _descriptor2, this);
    _initializerDefineProperty(this, "permissionChecker", _descriptor3, this);
    _initializerDefineProperty(this, "selectedYear", _descriptor4, this);
    _initializerDefineProperty(this, "selectedCourseId", _descriptor5, this);
    _initializerDefineProperty(this, "years", _descriptor6, this);
    _initializerDefineProperty(this, "allCourses", _descriptor7, this);
    _defineProperty(this, "setup", _buildTask(() => ({
      context: this,
      generator: function* (element, [session]) {
        if (!session) {
          return;
        }
        const course = yield session.course;
        const school = yield course.school;
        const {
          years,
          schoolCourses
        } = yield hash({
          years: this.store.findAll('academic-year'),
          schoolCourses: this.store.query('course', {
            filters: {
              school: school.id
            }
          })
        });
        const now = DateTime.now();
        const thisYear = now.year;
        this.years = years.map(year => Number(year.id)).filter(year => year >= thisYear - 1).sort();
        this.allCourses = yield filter(schoolCourses, async co => {
          return this.permissionChecker.canCreateSession(co);
        });
      }
    }), null, "setup", "restartable"));
    _defineProperty(this, "save", _buildTask(() => ({
      context: this,
      generator: function* () {
        yield timeout(10);
        const sessionToCopy = this.args.session;
        const newCourse = this.bestSelectedCourse;
        const toSave = [];
        const session = this.store.createRecord('session', sessionToCopy.getProperties('title', 'description', 'attireRequired', 'equipmentRequired', 'supplemental', 'attendanceRequired', 'instructionalNotes'));
        session.set('course', newCourse);
        session.set('meshDescriptors', yield sessionToCopy.meshDescriptors);
        session.set('terms', yield sessionToCopy.terms);
        session.set('sessionType', yield sessionToCopy.sessionType);
        const ilmToCopy = yield sessionToCopy.ilmSession;
        if (ilmToCopy) {
          const ilm = this.store.createRecord('ilmSession', ilmToCopy.getProperties('hours', 'dueDate'));
          ilm.set('session', session);
          toSave.push(ilm);
        }
        const learningMaterialsToCopy = yield sessionToCopy.learningMaterials;
        for (let i = 0; i < learningMaterialsToCopy.length; i++) {
          const learningMaterialToCopy = learningMaterialsToCopy.slice()[i];
          const lm = yield learningMaterialToCopy.learningMaterial;
          const learningMaterial = this.store.createRecord('session-learning-material', learningMaterialToCopy.getProperties('notes', 'required', 'publicNotes', 'position'));
          learningMaterial.set('learningMaterial', lm);
          learningMaterial.set('session', session);
          toSave.push(learningMaterial);
        }
        const originalCourse = yield sessionToCopy.course;
        if (newCourse.id === originalCourse.id) {
          const postrequisiteToCopy = yield sessionToCopy.postrequisite;
          session.set('postrequisite', postrequisiteToCopy);
        }

        // save the session first to fill out relationships with the session id
        yield session.save();
        yield yield all(toSave.map(o => o.save()));

        //parse objectives last because it is a many2many relationship
        //and ember data tries to save it too soon
        const relatedSessionObjectives = yield sessionToCopy.sessionObjectives;
        const sessionObjectivesToCopy = sortBy(relatedSessionObjectives, 'id');
        for (let i = 0, n = sessionObjectivesToCopy.length; i < n; i++) {
          const sessionObjectiveToCopy = sessionObjectivesToCopy[i];
          const meshDescriptors = yield sessionObjectiveToCopy.meshDescriptors;
          const terms = yield sessionObjectiveToCopy.terms;
          const sessionObjective = this.store.createRecord('session-objective', {
            session,
            position: sessionObjectiveToCopy.position,
            title: sessionObjectiveToCopy.title
          });
          sessionObjective.set('meshDescriptors', meshDescriptors);
          sessionObjective.set('terms', terms);
          yield sessionObjective.save();
        }
        this.flashMessages.success('general.copySuccess');
        return this.args.visit(session);
      }
    }), null, "save", "drop"));
  }
  get bestSelectedYear() {
    if (this.selectedYear) {
      return this.selectedYear;
    }
    return this.years[0];
  }
  get courses() {
    if (!this.allCourses) {
      return null;
    }
    return sortBy(this.allCourses.filter(course => course.year === this.bestSelectedYear), 'title');
  }
  get bestSelectedCourse() {
    if (this.selectedCourseId) {
      const course = findById(this.courses, this.selectedCourseId);
      if (course) {
        return course;
      }
    }
    return this.courses[0];
  }
  changeSelectedYear(event) {
    this.selectedCourseId = null;
    this.selectedYear = Number(event.target.value);
  }
  changeSelectedCourseId(event) {
    this.selectedCourseId = event.target.value;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "permissionChecker", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "selectedYear", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "selectedCourseId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "years", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "allCourses", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "changeSelectedYear", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeSelectedYear"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeSelectedCourseId", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeSelectedCourseId"), _class.prototype), _class);
export { SessionCopyComponent as default };